export * from "./brand-spotlight.component";
